/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FlaccPainScaleAliases {
  ACTIVITY_FIELD = 'activity-field',
  ACTIVITY_FORM = 'activity-form',
  ACTIVITY_RADIO_GROUP = 'activity-radio-group',
  ACTIVITY_TEXT = 'activity-text',
  CONSOLATION_FIELD = 'consolation-field',
  CONSOLATION_FORM = 'consolation-form',
  CONSOLATION_RADIO_GROUP = 'consolation-radio-group',
  CONSOLATION_TEXT = 'consolation-text',
  CRYING_FIELD = 'crying-field',
  CRYING_FORM = 'crying-form',
  CRYING_RADIO_GROUP = 'crying-radio-group',
  CRYING_TEXT = 'crying-text',
  FACE_FIELD = 'face-field',
  FACE_FORM = 'face-form',
  FACE_RADIO_GROUP = 'face-radio-group',
  FACIAL_TEXT = 'facial-text',
  FLACC_PAIN_SCALE_LAYOUT = 'flacc-pain-scale-layout',
  FPS_CONTEXTUAL_BAR = 'fps-contextualBar',
  FPS_PANEL = 'fps-panel',
  LEGS_FIELD = 'legs-field',
  LEGS_FORM = 'legs-form',
  LEGS_RADIO_GROUP = 'legs-radio-group',
  LEGS_TEXT = 'legs-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  REFERENCE_LINK = 'reference-link',
  REFERENCE_MODAL = 'reference-modal',
  REFERENCE_PANEL = 'reference-panel',
  TEXT_PAIN_SCALE_FIELD_REFERENCE = 'text-pain-scale-field-reference',
}
export { FlaccPainScaleAliases };
